module.exports = __webpack_public_path__ + "img/empty.3eb5dcdf.png";